/* <showroom-band> -- WAI-ARIA tabs over the showroom city selector.
   Delegated click/keydown; manual activation is NOT used -- the design
   has one interaction (pick a city), so arrows move focus AND select,
   per the ARIA tabs pattern's selection-follows-focus variant. */
(() => {
  if (customElements.get('showroom-band')) return;

  class ShowroomBand extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-showroom-target]'));
      if (!this.tabs.length) return;
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onClick = (event) => {
      const tab = event.target.closest('[data-showroom-target]');
      if (tab && this.contains(tab)) this.activate(tab);
    };

    onKeydown = (event) => {
      const tab = event.target.closest('[data-showroom-target]');
      if (!tab) return;
      const i = this.tabs.indexOf(tab);
      let next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % this.tabs.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + this.tabs.length) % this.tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this.tabs.length - 1;
      if (next === null) return;
      event.preventDefault();
      this.activate(this.tabs[next]);
      this.tabs[next].focus();
    };

    onBlockSelect = (event) => {
      const tab = this.querySelector(`[data-showroom-target="${event.detail.blockId}"]`);
      if (tab) this.activate(tab);
    };

    activate(tab) {
      const id = tab.getAttribute('data-showroom-target');
      this.tabs.forEach((t) => {
        const active = t === tab;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) t.removeAttribute('tabindex');
        else t.setAttribute('tabindex', '-1');
      });
      this.querySelectorAll('[data-showroom-panel]').forEach((panel) => {
        panel.toggleAttribute('hidden', panel.getAttribute('data-showroom-panel') !== id);
      });
      // The mobile city row is one no-wrap scroller, so the activated tab
      // can sit off-screen (arrow keys, or a block select in the editor).
      // inline/block 'nearest' only moves what it has to -- no page jump.
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  customElements.define('showroom-band', ShowroomBand);
})();
